import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { ORIGENES_OC } from "./ComprasUtils";
import { subirDatos, subirDatosSingle, eliminarDato } from "./syncSupabase";
const estadosCompra = { pendiente: { label: "⏳ Pendiente", color: "#f59e0b" }, aprobada: { label: "✅ Aprobada", color: "#22c55e" }, en_proceso: { label: "🔵 En proceso", color: "#3b82f6" }, recibida: { label: "📦 Recibida", color: "#808085" }, rechazada: { label: "🔴 Rechazada", color: "#e63946" }, cancelada: { label: "🚫 Cancelada", color: "#6b7280" } };
const ESTADOS_TERMINALES = ["recibida", "cancelada", "rechazada"];
const categoriasCompra = ["Materia prima", "Insumos de impresión", "Cartulina / Cartón", "Tintas y barnices", "Equipamiento", "Mantenimiento", "Servicios", "Insumos de oficina", "EPP / Seguridad", "Otro"];
function generarCodCompra(lista) { return `OC-${new Date().getFullYear()}-${String(lista.length + 1).padStart(4, "0")}`; }
function fechaHoy() { return new Date().toISOString().slice(0, 10); }
// ─── Integración automática con Finanzas ───
// Al recibir una compra, genera la CxP + el asiento contable (Debe Compras/egreso / Haber CxP)
// de forma idempotente (no duplica si la compra ya generó su CxP antes).
function generarCxPCompra(compra) {
  try {
    const cxpActuales = JSON.parse(localStorage.getItem('alqos_cxc_cxp') || '[]');
    if (cxpActuales.some(i => i.origenCompraId === compra.id)) return; // ya generada
    const configRaw = localStorage.getItem('alqos_finanzas_config');
    const config = configRaw ? JSON.parse(configRaw) : null;
    if (!config || !config.cuentaCxPDefault || !config.cuentaComprasDefault) return; // Finanzas sin configurar, no interrumpe Compras
    const cuentas = JSON.parse(localStorage.getItem('alqos_plan_cuentas') || '[]');
    const cuentaCxP = cuentas.find(c => c.id === config.cuentaCxPDefault);
    const cuentaCompras = cuentas.find(c => c.id === config.cuentaComprasDefault);
    if (!cuentaCxP || !cuentaCompras) return;
    const monto = Number(compra.monto) || 0;
    if (monto <= 0) return;
    const fecha = new Date().toISOString().slice(0, 10);
    const nuevaCxP = {
      id: Math.floor(Date.now()),
      tipo: 'pagar',
      entidadNombre: compra.proveedor,
      documentoOrigen: compra.codigo,
      montoOriginal: monto,
      montoPendiente: monto,
      fechaEmision: fecha,
      fechaVencimiento: null,
      estado: 'pendiente',
      origenCompraId: compra.id,
    };
    localStorage.setItem('alqos_cxc_cxp', JSON.stringify([nuevaCxP, ...cxpActuales]));
    subirDatos('alqos_cxc_cxp');
    const asientos = JSON.parse(localStorage.getItem('alqos_asientos') || '[]');
    const lineas = JSON.parse(localStorage.getItem('alqos_asientos_lineas') || '[]');
    const nroAsiento = (Number(config.ultimoAsiento) || 0) + 1;
    const numero = `A-${new Date().getFullYear()}-${String(nroAsiento).padStart(5, '0')}`;
    const asientoId = Math.floor(Date.now()) + 1;
    const nuevoAsiento = {
      id: asientoId, numero, fecha, concepto: `Compra recibida ${compra.codigo} — ${compra.proveedor}`,
      totalDebe: monto, totalHaber: monto, estado: 'confirmado',
      origenCompraId: compra.id, generadoAutomaticamente: true,
    };
    const nuevasLineas = [
      { id: Math.floor(Date.now()) + 2, asientoId, cuentaId: cuentaCompras.id, debe: monto, haber: 0 },
      { id: Math.floor(Date.now()) + 3, asientoId, cuentaId: cuentaCxP.id, debe: 0, haber: monto },
    ];
    localStorage.setItem('alqos_asientos', JSON.stringify([nuevoAsiento, ...asientos]));
    subirDatos('alqos_asientos');
    localStorage.setItem('alqos_asientos_lineas', JSON.stringify([...lineas, ...nuevasLineas]));
    subirDatos('alqos_asientos_lineas');
    // Actualiza saldos — misma convención de signos que AsientosContables.js
    // egreso: +debe-haber = +monto · pasivo: +haber-debe = +monto
    const cuentasActualizadas = cuentas.map(c => {
      if (c.id === cuentaCompras.id || c.id === cuentaCxP.id) return { ...c, saldo: (Number(c.saldo) || 0) + monto };
      return c;
    });
    localStorage.setItem('alqos_plan_cuentas', JSON.stringify(cuentasActualizadas));
    subirDatos('alqos_plan_cuentas');
    const nuevaConfig = { ...config, ultimoAsiento: nroAsiento };
    localStorage.setItem('alqos_finanzas_config', JSON.stringify(nuevaConfig));
    subirDatosSingle('alqos_finanzas_config', 'finanzas_config');
  } catch (e) {
    console.error('Error generando CxP automática de compra:', e);
  }
}
export default function Compras({ onVolver, oscuro, usuario }) {
  const [compras, setCompras] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_compras') || '[]'); } catch { return []; }
  });
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ estado: "pendiente", categoria: "Materia prima", fecha: fechaHoy() });
  const [detalle, setDetalle] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [busqueda, setBusqueda] = useState("");
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [mostrarRechazo, setMostrarRechazo] = useState(false);
  const [motivoCancelacion, setMotivoCancelacion] = useState("");
  const [mostrarCancelacion, setMostrarCancelacion] = useState(false);
  const [editando, setEditando] = useState(false);
  const [formEdicion, setFormEdicion] = useState(null);
  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";
  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: oscuro ? "#9aabd4" : "#555", fontWeight: "600", display: "block", marginTop: "12px" };
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };
  const guardar = () => {
    const nueva = { ...form, id: Date.now(), codigo: generarCodCompra(compras), fechaCreacion: new Date().toISOString(), creadoPor: usuario?.nombre || "Sistema", rolCreador: usuario?.rol || "" };
    const nuevas = [...compras, nueva];
    setCompras(nuevas);
    localStorage.setItem('alqos_compras', JSON.stringify(nuevas));
    subirDatos('alqos_compras');
    setForm({ estado: "pendiente", categoria: "Materia prima", fecha: fechaHoy() });
    setVista("listado");
  };
  const eliminar = async (id) => {
    const nuevas = compras.filter(c => c.id !== id);
    setCompras(nuevas);
    localStorage.setItem('alqos_compras', JSON.stringify(nuevas));
    await eliminarDato('alqos_compras', id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };
  const cambiarEstado = (id, nuevoEstado) => {
    const actualizadas = compras.map(c => c.id === id ? { ...c, estado: nuevoEstado, ultimoCambio: new Date().toISOString(), cambiadoPor: usuario?.nombre } : c);
    setCompras(actualizadas);
    localStorage.setItem('alqos_compras', JSON.stringify(actualizadas));
    subirDatos('alqos_compras');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: nuevoEstado }));
    if (nuevoEstado === 'recibida') {
      const compraActualizada = actualizadas.find(c => c.id === id);
      if (compraActualizada) generarCxPCompra(compraActualizada);
    }
  };
  const aprobarOC = (id) => {
    const actualizadas = compras.map(c => c.id === id ? {
      ...c, estado: "aprobada",
      aprobadaPor: usuario?.nombre, fechaAprobacion: new Date().toISOString(),
      rechazadaPor: null, motivoRechazo: null,
    } : c);
    setCompras(actualizadas);
    localStorage.setItem("alqos_compras", JSON.stringify(actualizadas));
    subirDatos('alqos_compras');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: "aprobada", aprobadaPor: usuario?.nombre, fechaAprobacion: new Date().toISOString() }));
  };
  const rechazarOC = (id) => {
    if (!motivoRechazo.trim()) { alert("Ingresá el motivo de rechazo"); return; }
    const actualizadas = compras.map(c => c.id === id ? {
      ...c, estado: "rechazada",
      rechazadaPor: usuario?.nombre, motivoRechazo,
      aprobadaPor: null, fechaAprobacion: null,
    } : c);
    setCompras(actualizadas);
    localStorage.setItem("alqos_compras", JSON.stringify(actualizadas));
    subirDatos('alqos_compras');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: "rechazada", rechazadaPor: usuario?.nombre, motivoRechazo }));
    setMotivoRechazo(""); setMostrarRechazo(false);
  };
  // ─── Cancelación (14/08) ───
  // Distinta de "rechazar": rechazar es cuando Compras nunca aprueba la OC (se corta en pendiente).
  // Cancelar es cuando la OC ya venía caminando (aprobada / en_proceso) y las condiciones cambiaron
  // (se recuperó el stock, cambió el proveedor, etc.) y hay que frenarla.
  const puedeCancelar = (compra) => {
    if (!compra) return false;
    if (!["aprobada", "en_proceso"].includes(compra.estado)) return false;
    return esAdmin || usuario?.rol === "Compras" || usuario?.rol === "Producción" || usuario?.nombre === compra.creadoPor;
  };
  const cancelarOC = (id) => {
    if (!motivoCancelacion.trim()) { alert("Ingresá el motivo de la cancelación"); return; }
    const actualizadas = compras.map(c => c.id === id ? {
      ...c, estado: "cancelada",
      canceladaPor: usuario?.nombre, motivoCancelacion, fechaCancelacion: new Date().toISOString(),
    } : c);
    setCompras(actualizadas);
    localStorage.setItem("alqos_compras", JSON.stringify(actualizadas));
    subirDatos('alqos_compras');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: "cancelada", canceladaPor: usuario?.nombre, motivoCancelacion }));
    setMotivoCancelacion(""); setMostrarCancelacion(false);
  };
  // ─── Edición (14/08) ───
  // Admin, Compras y Producción pueden corregir los datos de la OC mientras no esté en un estado terminal
  // (recibida / cancelada / rechazada). Si ya se recibió o se cerró, no se toca: se cancela y se genera una nueva.
  const puedeEditar = (compra) => {
    if (!compra) return false;
    if (ESTADOS_TERMINALES.includes(compra.estado)) return false;
    return esAdmin || usuario?.rol === "Compras" || usuario?.rol === "Producción";
  };
  const iniciarEdicion = (compra) => {
    setFormEdicion({
      descripcion: compra.descripcion || "", proveedor: compra.proveedor || "", cantidad: compra.cantidad || "",
      unidad: compra.unidad || "", monto: compra.monto || "", fecha: compra.fecha || "", fechaEntrega: compra.fechaEntrega || "",
      solicitadoPor: compra.solicitadoPor || "", justificacion: compra.justificacion || "", observaciones: compra.observaciones || "",
    });
    setEditando(true);
  };
  const guardarEdicion = (id) => {
    const actualizadas = compras.map(c => c.id === id ? { ...c, ...formEdicion, ultimaEdicion: new Date().toISOString(), editadoPor: usuario?.nombre } : c);
    setCompras(actualizadas);
    localStorage.setItem("alqos_compras", JSON.stringify(actualizadas));
    subirDatos('alqos_compras');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, ...formEdicion, editadoPor: usuario?.nombre }));
    setEditando(false); setFormEdicion(null);
  };
  const comprasFiltradas = compras.filter(c => {
    const matchEstado = filtroEstado === "todos" || c.estado === filtroEstado;
    const matchBusqueda = !busqueda || c.descripcion?.toLowerCase().includes(busqueda.toLowerCase()) || c.codigo?.toLowerCase().includes(busqueda.toLowerCase()) || c.proveedor?.toLowerCase().includes(busqueda.toLowerCase());
    return matchEstado && matchBusqueda;
  });
  const resumen = { total: compras.length, pendientes: compras.filter(c => c.estado === "pendiente").length, aprobadas: compras.filter(c => c.estado === "aprobada").length, totalMonto: compras.reduce((acc, c) => acc + (Number(c.monto) || 0), 0) };
  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
        <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
      </div>
      {extra}
    </div>
  );
  if (confirmEliminar) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: cardBg, borderRadius: "16px", padding: "2rem", maxWidth: "360px", width: "90%", border: `1px solid ${borde}`, textAlign: "center" }}>
        <p style={{ fontSize: "32px", marginBottom: "1rem" }}>🛒</p>
        <p style={{ fontSize: "15px", fontWeight: "600", color: texto, marginBottom: ".5rem" }}>¿Eliminar esta orden de compra?</p>
        <p style={{ fontSize: "13px", color: subtexto, marginBottom: "1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding: "10px 20px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{ padding: "10px 20px", background: "#e63946", border: "none", borderRadius: "10px", cursor: "pointer", color: "white", fontSize: "13px", fontWeight: "600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );
  if (vista === "detalle" && detalle) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={detalle.codigo}
        onBack={() => { setDetalle(null); setVista("listado"); setEditando(false); setFormEdicion(null); }}
        extra={
          <div style={{ display: "flex", gap: "8px" }}>
            {puedeEditar(detalle) && !editando && (
              <button onClick={() => iniciarEdicion(detalle)} style={{ background: "rgba(123,91,242,.2)", border: "1px solid rgba(123,91,242,.4)", color: "#7B5BF2", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>✏️ Editar</button>
            )}
            {esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background: "rgba(230,57,70,.2)", border: "1px solid rgba(230,57,70,.4)", color: "#e63946", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px" }}>🗑 Eliminar</button>}
          </div>
        }
      />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        {editando && formEdicion ? (
          <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
            <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#7B5BF2", marginBottom: "10px" }}>✏️ Editando OC {detalle.codigo}</h3>
            {[{ key: "descripcion", label: "Descripción del artículo/servicio", multiline: true }, { key: "proveedor", label: "Proveedor" }, { key: "cantidad", label: "Cantidad" }, { key: "unidad", label: "Unidad (kg, litros, unidades...)" }, { key: "monto", label: "Monto total estimado ($)" }, { key: "fecha", label: "Fecha de pedido", type: "date" }, { key: "fechaEntrega", label: "Fecha de entrega esperada", type: "date" }, { key: "solicitadoPor", label: "Solicitado por (área/persona)" }, { key: "justificacion", label: "Justificación de la compra", multiline: true }, { key: "observaciones", label: "Observaciones", multiline: true }].map(({ key, label, type, multiline }) => (
              <div key={key}>
                <span style={lbl}>{label}</span>
                {multiline
                  ? <textarea rows={2} value={formEdicion[key]} onChange={e => setFormEdicion(f => ({ ...f, [key]: e.target.value }))} style={{ ...inp, resize: "none" }} />
                  : <input type={type || "text"} value={formEdicion[key]} onChange={e => setFormEdicion(f => ({ ...f, [key]: e.target.value }))} style={inp} />}
              </div>
            ))}
            <div style={{ display: "flex", gap: "8px", marginTop: "14px" }}>
              <button onClick={() => guardarEdicion(detalle.id)} style={{ flex: 1, padding: "10px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontSize: "13px", fontWeight: "700" }}>💾 Guardar cambios</button>
              <button onClick={() => { setEditando(false); setFormEdicion(null); }} style={{ padding: "10px 16px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
            </div>
          </div>
        ) : (
          <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
            <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "10px" }}>Datos de la compra</h3>
            {[["Código OC", detalle.codigo], ["Origen Pre Prensa", detalle.origenPP||null], ["Cliente PP", detalle.clientePP||null], ["Trabajo PP", detalle.trabajoPP||null], ["Categoría", detalle.categoria], ["Proveedor", detalle.proveedor], ["Descripción", detalle.descripcion], ["Cantidad", detalle.cantidad], ["Unidad", detalle.unidad], ["Monto total", detalle.monto ? `$ ${detalle.monto}` : null], ["Fecha pedido", detalle.fecha], ["Fecha entrega esperada", detalle.fechaEntrega], ["Solicitado por", detalle.solicitadoPor], ["Creado por", `${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k, v]) => v && (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
                <span style={{ color: subtexto }}>{k}</span>
                <span style={{ color: texto, fontWeight: "500", maxWidth: "60%", textAlign: "right" }}>{v}</span>
              </div>
            ))}
            {detalle.editadoPor && <p style={{ fontSize: "11px", color: subtexto, marginTop: "8px" }}>Última edición: {detalle.ultimaEdicion?.slice(0, 16).replace("T", " ")} por {detalle.editadoPor}</p>}
          </div>
        )}
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#7B5BF2", marginBottom: "12px" }}>Estado</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {Object.entries(estadosCompra).map(([val, { label, color }]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstado(detalle.id, val)}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: esAdmin ? "pointer" : "default", fontWeight: "600", border: detalle.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: detalle.estado === val ? `${color}22` : cardBg, color: detalle.estado === val ? color : subtexto }}>
                {label}
              </button>
            ))}
          </div>
          {detalle.ultimoCambio && <p style={{ fontSize: "11px", color: subtexto, marginTop: "8px" }}>Último cambio: {detalle.ultimoCambio?.slice(0, 16).replace("T", " ")} por {detalle.cambiadoPor}</p>}
        </div>
        {/* APROBACIÓN */}
{(esAdmin || usuario?.rol === "Compras") && detalle.estado === "pendiente" && (
          <div style={{ ...card, background: oscuro?"#0a1f5c":"#fffbeb", border:"1.5px solid #f59e0b" }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#f59e0b", marginBottom:"10px" }}>⏳ Aprobación requerida</h3>
            {!mostrarRechazo ? (
              <div style={{ display:"flex", gap:"8px" }}>
                <button onClick={() => aprobarOC(detalle.id)}
                  style={{ flex:1, padding:"10px", background:"#22c55e", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                  ✅ Aprobar OC
                </button>
                <button onClick={() => setMostrarRechazo(true)}
                  style={{ flex:1, padding:"10px", background:"#e63946", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                  ❌ Rechazar
                </button>
              </div>
            ) : (
              <div>
                <textarea rows={2} value={motivoRechazo} onChange={e=>setMotivoRechazo(e.target.value)}
                  placeholder="Motivo del rechazo..."
                  style={{ width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto, resize:"none", boxSizing:"border-box", marginBottom:"8px" }}/>
                <div style={{ display:"flex", gap:"8px" }}>
                  <button onClick={() => rechazarOC(detalle.id)}
                    style={{ flex:1, padding:"10px", background:"#e63946", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                    Confirmar rechazo
                  </button>
                  <button onClick={() => setMostrarRechazo(false)}
                    style={{ padding:"10px 16px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto, fontSize:"13px" }}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {/* CANCELACIÓN — distinta de rechazar: la OC ya venía aprobada / en proceso */}
        {puedeCancelar(detalle) && (
          <div style={{ ...card, background: oscuro?"#1a1a2e":"#f3f4f6", border:"1.5px solid #6b7280" }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#6b7280", marginBottom:"10px" }}>🚫 Cancelar esta OC</h3>
            {!mostrarCancelacion ? (
              <button onClick={() => setMostrarCancelacion(true)}
                style={{ width:"100%", padding:"10px", background:"#6b7280", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                🚫 Cancelar OC
              </button>
            ) : (
              <div>
                <textarea rows={2} value={motivoCancelacion} onChange={e=>setMotivoCancelacion(e.target.value)}
                  placeholder="Motivo de la cancelación (ej: se recuperó el stock, cambió el proveedor)..."
                  style={{ width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto, resize:"none", boxSizing:"border-box", marginBottom:"8px" }}/>
                <div style={{ display:"flex", gap:"8px" }}>
                  <button onClick={() => cancelarOC(detalle.id)}
                    style={{ flex:1, padding:"10px", background:"#6b7280", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                    Confirmar cancelación
                  </button>
                  <button onClick={() => setMostrarCancelacion(false)}
                    style={{ padding:"10px 16px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto, fontSize:"13px" }}>
                    Volver
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {detalle.aprobadaPor && (
          <div style={{ ...card, background: oscuro?"#0a1f0a":"#f0fff4", border:"1px solid #22c55e40" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#22c55e", margin:0 }}>✅ Aprobada por {detalle.aprobadaPor} — {detalle.fechaAprobacion?.slice(0,10)}</p>
          </div>
        )}
        {detalle.rechazadaPor && (
          <div style={{ ...card, background: oscuro?"#1a0505":"#fff5f5", border:"1px solid #e6394640" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#e63946", margin:"0 0 4px" }}>❌ Rechazada por {detalle.rechazadaPor}</p>
            <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>Motivo: {detalle.motivoRechazo}</p>
          </div>
        )}
        {detalle.canceladaPor && (
          <div style={{ ...card, background: oscuro?"#1a1a2e":"#f3f4f6", border:"1px solid #6b728040" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#6b7280", margin:"0 0 4px" }}>🚫 Cancelada por {detalle.canceladaPor} — {detalle.fechaCancelacion?.slice(0,10)}</p>
            <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>Motivo: {detalle.motivoCancelacion}</p>
          </div>
        )}
        {detalle.origen && ORIGENES_OC[detalle.origen] && (
          <div style={{ ...card, background: oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${ORIGENES_OC[detalle.origen].color}40` }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:ORIGENES_OC[detalle.origen].color, margin:"0 0 4px" }}>{ORIGENES_OC[detalle.origen].label} — Origen de la OC</p>
            {detalle.referenciaOrigen && <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>Referencia: {detalle.referenciaOrigen}</p>}
          </div>
        )}
        {detalle.justificacion && <div style={card}><h3 style={{ fontSize: "14px", fontWeight: "600", color: "#09184D", marginBottom: "8px" }}>Justificación</h3><p style={{ fontSize: "13px", color: texto, lineHeight: "1.6" }}>{detalle.justificacion}</p></div>}
        {detalle.observaciones && <div style={card}><h3 style={{ fontSize: "14px", fontWeight: "600", color: "#09184D", marginBottom: "8px" }}>Observaciones</h3><p style={{ fontSize: "13px", color: texto, lineHeight: "1.6" }}>{detalle.observaciones}</p></div>}
      </div>
    </div>
  );
  if (vista === "nueva") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo="Nueva Orden de Compra" onBack={() => setVista("listado")} />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "4px" }}>Trazabilidad automática</h3>
          <p style={{ fontSize: "12px", color: subtexto, margin: 0 }}>Creado por: <strong style={{ color: texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Datos de la compra</h3>
          <span style={lbl}>Categoría</span>
          <select onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))} style={inp} defaultValue="Materia prima">
            {categoriasCompra.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px", flexWrap: "wrap" }}>
            {Object.entries(estadosCompra).map(([val, { label, color }]) => (
              <button key={val} onClick={() => setForm(f => ({ ...f, estado: val }))}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: form.estado === val ? `${color}22` : cardBg, color: form.estado === val ? color : texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{ key: "descripcion", label: "Descripción del artículo/servicio" }, { key: "proveedor", label: "Proveedor" }, { key: "cantidad", label: "Cantidad" }, { key: "unidad", label: "Unidad (kg, litros, unidades...)" }, { key: "monto", label: "Monto total estimado ($)" }, { key: "fecha", label: "Fecha de pedido", type: "date" }, { key: "fechaEntrega", label: "Fecha de entrega esperada", type: "date" }, { key: "solicitadoPor", label: "Solicitado por (área/persona)" }, { key: "justificacion", label: "Justificación de la compra", multiline: true }, { key: "observaciones", label: "Observaciones", multiline: true }].map(({ key, label, type, multiline }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline ? <textarea rows={3} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={{ ...inp, resize: "none" }} /> : <input type={type || "text"} defaultValue={key === "fecha" ? fechaHoy() : ""} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />}
            </div>
          ))}
        </div>
        <button onClick={guardar} style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
          Guardar Orden de Compra
        </button>
      </div>
    </div>
  );
  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="compras" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="compras" oscuro={oscuro} />}
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>Compras</span>
        </div>
        <CampanaNotificaciones oscuro={oscuro} modulo="Compras" />
          {esAdmin && <button onClick={() => setVista("nueva")} style={{ padding: "6px 14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>+ Nueva OC</button>}
      </div>
      <div style={{ padding: "1rem 1.5rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginBottom: "1.5rem" }}>
          {[["Total OC", resumen.total, "#7B5BF2"], ["Pendientes", resumen.pendientes, "#f59e0b"], ["Aprobadas", resumen.aprobadas, "#22c55e"], ["Monto total", `$${resumen.totalMonto.toLocaleString('es-AR')}`, "#3b82f6"]].map(([lab, val, col]) => (
            <div key={lab} style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1px solid ${borde}`, textAlign: "center" }}>
              <p style={{ fontSize: lab === "Monto total" ? "14px" : "22px", fontWeight: "700", color: col, margin: 0 }}>{val}</p>
              <p style={{ fontSize: "11px", color: subtexto, margin: "4px 0 0" }}>{lab}</p>
            </div>
          ))}
        </div>
        <input placeholder="🔍 Buscar por descripción, código o proveedor..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...inp, marginBottom: "1rem", marginTop: 0 }} />
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltroEstado("todos")} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === "todos" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtroEstado === "todos" ? "rgba(123,91,242,.1)" : cardBg, color: filtroEstado === "todos" ? "#7B5BF2" : subtexto }}>Todas</button>
          {Object.entries(estadosCompra).map(([val, { label, color }]) => (
            <button key={val} onClick={() => setFiltroEstado(val)} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: filtroEstado === val ? `${color}22` : cardBg, color: filtroEstado === val ? color : subtexto }}>{label}</button>
          ))}
        </div>
        {comprasFiltradas.length === 0
          ? <div style={{ textAlign: "center", padding: "4rem" }}><p style={{ fontSize: "40px" }}>🛒</p><p style={{ fontSize: "15px", color: texto }}>No hay órdenes de compra registradas</p></div>
          : comprasFiltradas.map(c => (
              <div key={c.id} onClick={() => { setDetalle(c); setVista("detalle"); }}
                style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem 1.5rem", border: `1px solid ${borde}`, marginBottom: "10px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontWeight: "700", color: "#7B5BF2", fontSize: "13px" }}>{c.codigo}</span>
                    <span style={{ marginLeft: "10px", fontSize: "13px", color: texto, fontWeight: "600" }}>{c.descripcion || "Sin descripción"}</span>
                    {(c.origenPP||c.origen) && <span style={{ marginLeft:"6px", fontSize:"10px", fontWeight:"700", color: ORIGENES_OC[c.origen]?.color||"#2A7FFF", background:"#eff6ff", padding:"2px 6px", borderRadius:"6px" }}>{ORIGENES_OC[c.origen]?.label || `🖨️ PP: ${c.origenPP}`}</span>}
                    {c.estado==="pendiente" && (esAdmin||usuario?.rol==="Dirección") && <span style={{ marginLeft:"6px", fontSize:"10px", fontWeight:"700", color:"#f59e0b", background:"#fffbeb", padding:"2px 6px", borderRadius:"6px" }}>⏳ Requiere aprobación</span>}
                    <p style={{ fontSize: "12px", color: subtexto, marginTop: "4px" }}>{c.categoria} · Prov: {c.proveedor || "—"}{c.monto ? ` · $${Number(c.monto).toLocaleString('es-AR')}` : ""}</p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: estadosCompra[c.estado]?.color }}>{estadosCompra[c.estado]?.label}</span>
                    <span style={{ fontSize: "11px", color: subtexto }}>{c.fecha}</span>
                  </div>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: oscuro ? "#7B5BF2" : "#9b8cc4" }}>Creado por: {c.creadoPor}</div>
              </div>
            ))
        }
      </div>
    </div>
  );
}
